var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c(
          "a",
          {
            staticClass: "code-num",
            class: [
              "",
              "",
              {
                disabled: _vm.isTimeout,
                "code-num-ltr": !_vm.isDirection,
                "code-num-rtl": _vm.isDirection
              }
            ],
            on: { click: _vm.serGeet }
          },
          [
            _vm.isTimeout
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$t("300062", { timeout: _vm.timeout })))
                ])
              : _c("span", [_vm._v(_vm._s(_vm.$t("300061")))])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.isGeet
        ? _c("Geet", {
            attrs: {
              isGeet: _vm.isgt,
              product: "bind",
              userName: _vm.userName
            },
            on: { geetPath: _vm.GeetPath, clickChange: _vm.GeetChange }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12074bef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12074bef","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/sendCode.vue
// module id = ma07
// module chunks = 0